import * as apiGetStartingWithV1 from 'api/baseIngredient/GetBaseIngredientStartingWithV1';
import * as SelectItemList from 'types/_general/SelectItemList';
import * as BaseIngredient from 'types/_general/Store/BaseIngredient';

export type Type = BaseIngredient.Type[];

export function create(): Type {
	return [];
}

export function mapToSelectItemList(obj: Type): SelectItemList.Type {
	return obj.map((x: BaseIngredient.Type) => ({
		id: x.id,
		name: x.description,
	}));
}

export async function getFromApi(): Promise<Type> {
	const response = await apiGetStartingWithV1.callApi('', false);
	return response.getOrDefault([]);
}

export function getById(obj: Type, id: string | null): BaseIngredient.Type | undefined {
	return obj.find((e) => e.id === id);
}
